import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-section-intro',
  templateUrl: './page-section-intro.component.html',
  styleUrls: ['./page-section-intro.component.scss']
})
export class PageSectionIntroComponent implements OnInit {
  @Input() title: string;
  @Input() imageUrl: string;

  constructor() { }

  ngOnInit() {
  }

}
